import { LightningElement, api } from 'lwc';


import {
    formatTimeAgo
} from './helpers';

const LIST_VIEWS_DATA_ID = '[data-id="listViewsPopover"]';

// Find matching option when setting grouped options / current value
function findCurrentListView(groupedOptions, listViewTitle) {
    
    if (groupedOptions?.length && listViewTitle) {
        return (groupedOptions ?? [])
            .flatMap(obj => obj?.options ?? [])
            .filter(Boolean)
            .find(flatObj => 
                flatObj?.value === listViewTitle || flatObj.label === listViewTitle
            )?.value ?? null;
    }
    return null;
}

export default class sldsPageHeaderListViewGw extends LightningElement {
    @api filteredBy;
    @api sortedBy;

     currentListView;               // Selected list view
    _listViewTrigger;

    @api 
    set backgroundColor(val) {
        this._backgroundColor = val;
        this._applyVarsDirect('--c-page-header-background-color', val);
    }
    get backgroundColor() {
        return this._backgroundColor;
    }

    @api 
    set suppressBorders(val) {
        this._suppressBorders = val;
        if (val) {
            this._applyVarsDirect('--c-page-header-border', 'none');
        } else {
            this._applyVarsDirect('--c-page-header-border', 'solid 1px var(--slds-g-color-border-base-1)');
        }
    }
    get suppressBorders() {
        return this._suppressBorders;
    }

    @api overflowOptions = [];

    @api firstButtonLabel;
    @api secondButtonLabel;

    @api suppressRefresh = false;
    
    @api newButtonLabel;
    @api listLength;
    @api settingsOptions = [];
    @api changeViewOptions = [];

    // Handle Filter with a function
    @api filterFn;
    // Handle Charting with a function
    @api chartsFn;
    
    @api pageLabel;             // Top header title 
    _listViewTitle;
    @api 
    set listViewTitle(val) {
        this._listViewTitle = val;
        this.currentListView = findCurrentListView(this._groupedOptions, val);
    }
    get listViewTitle() {
        return this._listViewTitle;
    }
    @api 
    set icon(val) {
        if (val) {
            const parts = val.split(':');
            const iconName = parts?.[1] ?? null;
            const category = parts?.[0] ?? null;
            const iconClass = parts?.[2] ?? '';

            if (!iconName || !category) {
                return;
            }
            const iconContainerName = iconName.includes('_') 
                ? iconName.replaceAll('_', '-') 
                : iconName;
            
            this._icon = {
                container: `slds-icon_container slds-icon-${category}-${iconContainerName} ${iconClass}`,
                svg: `slds-icon slds-page-header__icon ${iconClass}`,
                icon: `static/assets/icons/${category}-sprite/svg/symbols.svg#${iconName}`
            }
        } else {
            this._icon = null;
        }
    }
    get icon() {
        return this._icon 
            ?? {
                container: 'slds-icon_container slds-icon-utility-custom',
                svg: 'slds-icon slds-page-header__icon',
                icon: 'static/assets/icons/utility-sprite/svg/symbols.svg#custom',
            };
    }


    // Handle a button beting clicked
    handleNewClick(event) {
        this._lastFocusedEl = event.target;
        // Get the button label the user provided
        const buttonNumber = event.target.dataset.id; 
        const buttonLabel = this[`${buttonNumber}Label`];

        
        
        this.dispatchEvent(new CustomEvent('buttonclick', { detail: buttonLabel } ));
    }

    handleNewListViewP(event) {
        this.dispatchEvent(new CustomEvent('listviewchange', {
            detail: event.detail
        }));
    }
    
    // ====================== List View Selector Handlers ====================== \\
    _groupedOptions = [];
    @api 
    set groupedOptions(val) {
        this._groupedOptions = val?.length 
            ? val
            : [];

        this.currentListView = findCurrentListView(val ?? [], this._listViewTitle)
    }
    get groupedOptions() {
        return this._groupedOptions;
    }

    // Display the "Change List View" options
    _lastFocusedEl;
    toggleListViewOptions(event=null) {
        try {
            if (event) {
                this._lastFocusedEl = event.target;
            }
            if (!this._listViewTrigger) {
                this._listViewTrigger = this.template.querySelector('[data-id="listViewTrigger"]');
            }

            if (this._listViewTrigger) {
                const isOpening = !this._listViewTrigger.classList.contains('slds-is-open');

                if (isOpening) {
                    this.openPopover();
                } else {
                    this.closePopover();
                }

            } 
        }catch(error) {
            console.error('sldsPageHeaderListView --> toggleListViewOptions()', error);
        }
    }
    // Close list views picklist popover
    closeListViewOptions() {
        if (!this._listViewTrigger) {
            this._listViewTrigger = this.template.querySelector('[data-id="listViewTrigger"]');
        }
        this._listViewTrigger.classList.remove('slds-is-open');
        const popover = this.template.querySelector(LIST_VIEWS_DATA_ID);
        if (popover) {
            popover.classList.add('slds-hide');
        }
    }
    // Handle selected list view
    // Handle the List View Value Custom Event sent by 'x-slds-combobox-grouped'
    handleNewListViewP(message) {
        try {
            // Get the new list view value from event sent by 'x-slds-combobox-grouped'
            const selection = message.detail.selection;

            // Hide the popover
            this.template.querySelector(LIST_VIEWS_DATA_ID).classList.add('slds-hide');
            
            this._listViewTrigger.classList.remove('slds-is-open');
            
            if (selection && selection !== this.currentListView) {
                // Update the the current list view
                this.currentListView = typeof selection === 'object'
                    ? selection.value
                    : selection;

                this.dispatchEvent(new CustomEvent('listviewchange', { 
                    detail: this.currentListView,
                    bubbles: true,
                    composed: true,
                } ));
            }

            this.focusListViewsButton(true);
        } catch(error) {
            this.showToast('Error in handleNewListViewP() of sldsPageHeaderListViewGw.js', error, 'error');
        } 
    }
    
    _isOpen = false;
    _onScroll = () => { if (this._isOpen) this.positionPopover(); };
    _onResize = () => { if (this._isOpen) this.positionPopover(); };
    openPopover() {
        this._isOpen = true;
        this._listViewTrigger.classList.add('slds-is-open');
        const listViewsPopover = this.template.querySelector(LIST_VIEWS_DATA_ID);
        listViewsPopover.classList.remove('slds-hide');
        requestAnimationFrame(() => this.positionPopover());
        window.addEventListener('scroll', this._onScroll, true);
        window.addEventListener('resize', this._onResize);
        this.positionPopover();
        setTimeout(() => {
            this.template.querySelector('x-slds-combobox-grouped').focusOpenMe();
        });
    }
    positionPopover() {
        const title = this.template.querySelector('[data-id="listViewTitle"]')
        const pop = this.template.querySelector(LIST_VIEWS_DATA_ID);
        if (!title || !pop) return;
        const r = title.getBoundingClientRect();
        pop.style.position = 'fixed';
        pop.style.top  = `${Math.round(r.bottom)}px`;
        pop.style.left = `${Math.round(r.left)}px`;
    }
    closePopover() {
        this._isOpen = false;
        this._listViewTrigger.classList.remove('slds-is-open');
        const pop = this.template.querySelector(LIST_VIEWS_DATA_ID);
        if (pop) {
            pop.classList.add('slds-hide');
        }
        window.removeEventListener('scroll', this._onScroll, true);
        window.removeEventListener('resize', this._onResize);
        this.focusListViewsButton(true);
    }
    focusListViewsButton(isAnimationFrame=false) {
        const btn = this?.refs?.listViewsButton;
        const active = document.activeElement; 
        if (btn) {
            if (isAnimationFrame) {
                requestAnimationFrame(() => {btn.focus();})
            } else {
                btn.focus();
            }
        }
    }
    // ========================================================================= \\
    handleLinkClick(event) {
        this._lastFocusedEl = event.target;
        event.preventDefault();
        event.stopPropagation();
        this.toggleListViewOptions();
    }

    lastRefreshed = new Date();
    currentTime = new Date(); // Continuously updated "now"
    // A getter that returns "x seconds ago", "10 minutes ago", etc.
    get lastRefreshedTimeAgo() {
        if (!this.lastRefreshed) {
            return '';
        }
        return formatTimeAgo(this.lastRefreshed, this.currentTime);
    }
    _intervalId
    connectedCallback() {
        // Update currentTime every 10 seconds (adjust as needed)
        this._intervalId = setInterval( () => {this.currentTime = new Date();}, 10000 );
    }
    // Remove Last Refreshed Polling Interval
    disconnectedCallback() {
        // Clear interval when component is removed
        if (this._intervalId) {
            clearInterval(this._intervalId);
        }
    }   

    get hasFilterOrChart() {
        return this.filterFn || this.chartsFn;
    }
    get metaTextCl() {
        return !this.settingsOptions.length && 
            !this.changeViewOptions.length && 
            this.suppressRefresh &&
            !this.hasFilterOrChart

            ? 'slds-page-header__meta-text slds-align-bottom slds-m-top-small'
            : 'slds-page-header__meta-text';
    }

    // Apply Styles to the host 👉 Can pass 1.Array of Arrays   2.Array of Object   3.Strings
    _applyVarsDirect(cssVar, varStyle=null) {

        // Check that CSS var starts with '--' and has a non-null stlye 
        const isValid = (cssVarP, varStyleP) => {
            return typeof cssVarP === 'string' && 
                typeof varStyleP === 'string' &&
                cssVarP?.startsWith('--') && 
                varStyleP;
        }



        const el = this.template.host;
        
        if (Array.isArray(cssVar)) {
            // Handle Array of vars
            cssVar.forEach(hostVar => {
                if (Array.isArray(hostVar) && isValid(hostVar[0], hostVar[1])) {
                    // Handle Array structure  (CSS var at index 0)
                    el.style.setProperty(hostVar[0], hostVar[1]);
                } else if (typeof hostVar === 'object' && isValid(hostVar.cssVar, hostVar.varStyle)) {
                    // Handle Object structure (cssVar & varStyle keys)
                    el.style.setProperty(hostVar.cssVar, hostVar.varStyle)
                }
            });
        } else if (isValid(cssVar, varStyle)) {
            // Handle string arguments
            el.style.setProperty(cssVar,  varStyle);
        }
    }
}